var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brains-infohelper-container"},[_c('font-awesome-icon',{staticClass:"brains-infohelper-icon",attrs:{"icon":"info-circle"}}),_c('div',{staticClass:"brains-infohelper-txt"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }